import { useQuery } from "@tanstack/react-query"

import { supabase } from "@/lib/supabase"
import { Person } from "@/types/person"

/**
 * The current row for a person, by people.id. Stays fresh: hooks that change
 * a person invalidate ["person", id], which refetches it here.
 */
export const usePerson = (personUuid: string | null) =>
  useQuery<Person>({
    queryKey: ["person", personUuid],
    enabled: !!personUuid,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("people")
        .select("*, has_multiple_locations")
        .eq("id", personUuid)
        .single()

      if (error) throw new Error(error.message)
      return data
    },
  })
